import { useAtom } from 'jotai'
import { toastsAtom } from '../store'
import { Toast, ToastContainer } from 'react-bootstrap'

const ToastsContainer = () => {
  const [toasts, setToasts] = useAtom(toastsAtom)

  const remove = (id: string) => setToasts(toasts.filter((t) => t.id !== id))

  return (
    <ToastContainer className="p-3 position-fixed" position="top-end">
      {toasts.map((t) => (
        <Toast key={t.id} bg={t.variant} onClose={() => remove(t.id)}>
          <Toast.Header>
            <strong className="me-auto">{t.title}</strong>
          </Toast.Header>
          <Toast.Body className="text-white">{t.message}</Toast.Body>
        </Toast>
      ))}
    </ToastContainer>
  )
}

export default ToastsContainer
